import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@insights-ltd/design-library/components';

export type ContactEmailErrorDialogProps = {
  open: boolean;
  onClose: () => void;
};

const ContactEmailErrorDialog = ({
  open,
  onClose,
}: ContactEmailErrorDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      aria-labelledby="contact-email-error-dialog-title"
      aria-describedby="contact-email-error-dialog-description"
      open={open}
      onClose={onClose}
      title={t('ui.event-management.contact.error-dialog-title')}
      content={
        <DialogContentText
          id="contact-email-error-dialog-description"
          color="textSecondary"
          variant="body1"
        >
          {t('ui.event-management.contact.error-dialog-description')}
        </DialogContentText>
      }
      secondaryButtonText={t(
        'ui.event-management.contact.error-dialog-ok-button',
      )}
    />
  );
};

export default ContactEmailErrorDialog;
